import { render, staticRenderFns } from "./WaterRipples.vue?vue&type=template&id=960cb3e6&scoped=true"
import script from "./WaterRipples.vue?vue&type=script&lang=js"
export * from "./WaterRipples.vue?vue&type=script&lang=js"
import style0 from "./WaterRipples.vue?vue&type=style&index=0&id=960cb3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960cb3e6",
  null
  
)

export default component.exports